/* eslint-disable no-unused-vars */
import Spider from "../../api/Spider";
import { spiderTypes } from "../types/spider.types";

export const getCesByCodSpider = (codSpider, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_CES_SPIDER });

  try {
    const response = await Spider.getCesByCodSpider(codSpider);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_CES_SPIDER_SUCCESS, payload: response.body });
  } catch (error) {
    console.log("response CES", error);
    dispatch({ type: spiderTypes.GET_CES_SPIDER_FAILED });
  }
};

export const getHomologation = (codCes, idIntegration, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_HOMOLOGATION });

  try {
    const response = await Spider.getHomologation(codCes, idIntegration);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_HOMOLOGATION_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_HOMOLOGATION_FAILED });
  }
};

export const getHomologatedCars = (codCes, idBrand, idModel, idIntegration, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_HOMOLOGATED_CARS });

  try {
    const response = await Spider.getHomologatedCars(codCes, idBrand, idModel, idIntegration);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_HOMOLOGATED_CARS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_HOMOLOGATED_CARS_FAILED });
  }
};

export const getHomologated = (codCes, idBrand, idIntegration, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_HOMOLOGATED });
  try {
    const response = await Spider.getHomologated(codCes, idBrand, idIntegration);
    if (cb) cb(response.body);
    dispatch({ type: spiderTypes.GET_HOMOLOGATED_SUCCESS, payload: response.body });
  } catch (error) {
    if (cb) cb([]);
    dispatch({ type: spiderTypes.GET_HOMOLOGATED_FAILED });
  }
};

export const inyectionTrinidad = (data, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.POST_INYECTION_TRINIDAD });

  try {
    const response = await Spider.inyectionTrinidad(data);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.POST_INYECTION_TRINIDAD_SUCCESS, payload: response.body });
  } catch (error) {
    window.location.href = "/page/error";
    dispatch({ type: spiderTypes.POST_INYECTION_TRINIDAD_FAILED });
  }
};

export const getTasaVFMG = (id, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_TASA_VFMG });

  try {
    const response = await Spider.getTasaVFMG(id);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_TASA_VFMG_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_TASA_VFMG_FAILED });
  }
};

export const getMarcas = (cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MARCAS });
  try {
    const response = await Spider.getMarcas();
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_MARCAS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MARCAS_FAILED, error });
  }
};

export const getMarcasByVehicleType = (vehicleType, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MARCAS });
  try {
    const { body } = await Spider.getMarcasByVehicleType(vehicleType);
    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_MARCAS_SUCCESS, payload: body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MARCAS_FAILED, error });
  }
};

export const getModelByVehicleType = (vehicleType, id, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MODELOS });
  try {
    const { body } = await Spider.getModelByVehicleType(vehicleType, id);

    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_MODELOS_SUCCESS, payload: body || [] });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MODELOS_FAILED, error });
  }
};

export const getTypeProducts = (businessType, vehicleStatus, cb) => async (
  dispatch
) => {
  dispatch({ type: spiderTypes.GET_TYPE_PRODUCTS });
  console.log("getTypeProducts");
  try {
    const response = await Spider.getProductos(businessType, vehicleStatus);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_TYPE_PRODUCTS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_TYPE_PRODUCTS_FAILED });
  }
};

export const getModelosById = (id, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MODELOS });

  try {
    const response = await Spider.getModelosById(id);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_MODELOS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MODELOS_FAILED });
  }
};

export const getBrandByModel = (model, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_BRAND_BY_MODEL });
  try {
    const response = await Spider.getBrandByModel(model);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_BRAND_BY_MODEL_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_BRAND_BY_MODEL_FAILED });
  }
};

export const getGastos = (cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_GASTOS });

  try {
    const response = await Spider.getGastos();
    if (cb) {
      cb(response.body);
    }
    console.log("response", response.body);
    dispatch({ type: spiderTypes.GET_GASTOS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_GASTOS_FAILED });
  }
};

export const getPlazos = (businessType, vehicleStatus, cb) => async (
  dispatch
) => {
  dispatch({ type: spiderTypes.GET_PLAZOS });
  try {
    const response = await Spider.getPlazos(businessType, vehicleStatus);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_PLAZOS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_PLAZOS_FAILED });
  }
};

export const getMonths = (cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_MONTHS });

  try {
    const response = await Spider.getMonths();
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_MONTHS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_MONTHS_FAILED });
  }
};

export const calculateFee = (data, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.POST_CALCULATE_FEE });

  try {
    const response = await Spider.calculateFee(data);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.POST_CALCULATE_FEE_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.POST_CALCULATE_FEE_FAILED });
  }
};

export const getRegistration = (id, cb) => async (dispatch) => {
  dispatch({ type: spiderTypes.GET_REGISTRATION });

  try {
    const { body } = await Spider.getRegistration(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: spiderTypes.GET_REGISTRATION_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_REGISTRATION_FAILED });
  }
};

export const getParam = (searchCode, cb) => async (
  dispatch
) => {
  dispatch({ type: spiderTypes.GET_TYPE_PARAMS });
  try {
    const response = await Spider.getParam(searchCode);
    if (cb) {
      cb(response.body);
    }
    dispatch({ type: spiderTypes.GET_TYPE_PARAMS_SUCCESS, payload: response.body });
  } catch (error) {
    dispatch({ type: spiderTypes.GET_TYPE_PARAMS_FAILED });
  }
};
